import { render } from "./ConfirmSize.vue?vue&type=template&id=2b748cd4"
import script from "./ConfirmSize.vue?vue&type=script&lang=js"
export * from "./ConfirmSize.vue?vue&type=script&lang=js"

import "./ConfirmSize.vue?vue&type=style&index=0&id=2b748cd4&lang=scss"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__